import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { api } from 'controllers/network/apiClient';

interface TotalSubscribersResponse {
  total: number;
}

export const TOTAL_SUBSCRIBERS_QUERY_KEY = 'totalSubscribers';
export const TOTAL_SUBSCRIBERS_URL = '/v2/subscribers/total/';

const fetchTotalSubscribers = async (): Promise<number> => {
  const response = await api.get<TotalSubscribersResponse>(
    TOTAL_SUBSCRIBERS_URL,
  );
  return response.total;
};

export const useTotalSubscribers = (
  options?: UseQueryOptions<
    number,
    any,
    number,
    [typeof TOTAL_SUBSCRIBERS_QUERY_KEY]
  >,
): UseQueryResult<number> =>
  useQuery({
    queryKey: [TOTAL_SUBSCRIBERS_QUERY_KEY],
    queryFn: fetchTotalSubscribers,
    ...options,
    staleTime: 5_000 * 60,
  });
